import { getAuth, onAuthStateChanged } from "firebase/auth"
import store from "@/store"
import router from "@/router"

/**
 * Initializes a global Firebase Auth state listener.
 * Logs out and redirects to login if the user is signed out (token expired or manual sign out).
 */
export function initAuthListener() {
  const auth = getAuth()
  onAuthStateChanged(auth, (user) => {
    if (!user) {
      store.dispatch("signOut")
      router.push({ name: "login" })
    }
  })
}
